<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">
    <b-row class="justify-content-center marginalbotsm">
        <b-col cols="auto">
            <b-button @click="activePlugin = 'noDRM'" :variant="(activePlugin === 'noDRM') ? 'greenw':'msstreamblue'">{{$ml.get('examplenodrm')}}</b-button>
            &nbsp;
            <b-button @click="activePlugin = 'withDRM'" :variant="(activePlugin !== 'noDRM') ? 'greenw':'msstreamblue'" >{{$ml.get('exampledrm')}}</b-button>
        </b-col>
    </b-row>
    <b-row class="mt-2">
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Flowplayer and integrating **QUANTEEC** without DRM.
```html
&lt;head>
    &lt;link rel="stylesheet" href="https://cdn.flowplayer.com/releases/native/3/stable/style/flowplayer.css">

    &lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script>
    &lt;script src="https://cdn.flowplayer.com/releases/native/3/stable/flowplayer.min.js">&lt;/script>
    &lt;script src="https://cdn.flowplayer.com/releases/native/3/stable/plugins/hls.min.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/0.1.0/quanteec-hlsjs.min.js">&lt;/script> <!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;div style="max-width:726px;max-height:408px;">
        &lt;div id="videoplayer" >&lt;/div>
    &lt;/div>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}",
            };

            // 3-Link QUANTEEC to flowplayer *before* the creation of the flowplayer instance
            var quanteecPlayer = new Quanteec(configQuanteec, flowplayer);

            // 4-Add hls parameters in the options of flowplayer
            var flow = flowplayer('#videoplayer',
            { 
               src: videoSource, 
                hls: {
                    pLoader: quanteecPlayer.loader,
                    fLoader: quanteecPlayer.loader
                },
                autoplay: true
            })

            // 5-Declare your flowplayer instance to QUANTEEC
            quanteecPlayer.setFlowplayer(flow);
        });
    &lt;/script>
&lt;/body>   
    </vue-markdown>


    <vue-markdown :show="activePlugin === 'withDRM'" style="overflow: auto;" class="col-7" :style="(activePlugin === 'noDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Flowplayer and integrating **QUANTEEC** with DRM. The documentation can be found [here](https://docs.flowplayer.com/plugins/drm).
```html
&lt;head>
    &lt;link rel="stylesheet" href="https://cdn.flowplayer.com/releases/native/3/stable/style/flowplayer.css">

    &lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script>
    &lt;script src="https://cdn.flowplayer.com/releases/native/3/stable/flowplayer.min.js">&lt;/script>
    &lt;script src="//cdn.flowplayer.com/releases/native/3/stable/plugins/drm.min.js"> &lt;/script> &lt;!-- Script for DRMs -->
    &lt;script src="https://cdn.flowplayer.com/releases/native/3/stable/plugins/hls.min.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/0.1.0/quanteec-hlsjs.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;div style="max-width:726px;max-height:408px;">
        &lt;div id="videoplayer" >&lt;/div>
    &lt;/div>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}",
            };

            // 3-Link QUANTEEC to flowplayer *before* the creation of the flowplayer instance
            var quanteecPlayer = new Quanteec(configQuanteec, flowplayer);

            // 4-Add hls parameters in the options of flowplayer
            var flow = flowplayer('#videoplayer',
            { 
               src:  
               [
                    {
                        src : videoSource,
                        // DRM part
                        drm: {
                            [flowplayer.drm.WIDEVINE]: { [flowplayer.drm.LICENSE_SERVER]: "URL_TO_LICENSE_SERVER" },
                            [flowplayer.drm.PLAYREADY]: { [flowplayer.drm.LICENSE_SERVER]: "URL_TO_LICENSE_SERVER" }
                        }
                        // End DRM part
                    }
                ], 
                hls: {
                    pLoader: quanteecPlayer.loader,
                    fLoader: quanteecPlayer.loader
                },
                autoplay: true
            })

            // 5-Declare your flowplayer instance to QUANTEEC
            quanteecPlayer.setFlowplayer(flow);
        });
    &lt;/script>
&lt;/body>   
    </vue-markdown>

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
    </b-row>
</b-col>
</b-row>
</b-container>
</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'FlowplayerNative',
  data: function() {
    return {
     activePlugin:"noDRM",     
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
      onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }        
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>